<div class="form-container">
    <div class="inline">
        <h4>Partner Users</h4>
    </div>&nbsp; &nbsp;
    <div class="inline" *ngIf="canAddPartnerUser">
        <button pButton type="button" label="Add User" (click)="showAddDialog()"></button>
    </div>  
</div>
<br><br>
<p-messages [value]="messages"></p-messages>
<p-table #dt [value]="partnerUserDataGroup" autoLayout=true [paginator]="true" [rows]="10" [loading]="loading" 
    [rowsPerPageOptions]="[10,25,50,100]" 
    [globalFilterFields]="['PartnerUser.Person.FirstName', 'PartnerUser.Person.LastName', 'PartnerUser.Person.Phone', 'PartnerUser.Person.Email']" 
    dataKey="PartnerUser.Person.PersonId">
   <ng-template pTemplate="caption">
        <div class="search-container">        
            <i class="pi pi-search filterInput"></i>
            <input type="text" pInputText size="50" placeholder="Filter By:Name, Phone and Email" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
    </ng-template>    
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 3em"></th>
            <th [pSortableColumn]="'PartnerUser.Person.IsActive'">Status <p-sortIcon [field]="'PartnerUser.Person.IsActive'"></p-sortIcon></th>
            <th [pSortableColumn]="'PartnerUser.Person.LastName'">Full Name<p-sortIcon [field]="'PartnerUser.Person.LastName'"></p-sortIcon></th>
            <th [pSortableColumn]="'PartnerUser.Person.Phone'">Phone <p-sortIcon [field]="'PartnerUser.Person.Phone'"></p-sortIcon></th>
            <th [pSortableColumn]="'PartnerUser.Person.Email'">Email <p-sortIcon [field]="'PartnerUser.Person.Email'"></p-sortIcon></th>            
            <th [pSortableColumn]="'PartnerUser.UniqueKey'">Unique Key <p-sortIcon [field]="'PartnerUser.UniqueKey'"></p-sortIcon></th>
            <th>Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-partner let-expanded="expanded">
        <tr>
            <td>
                <a href="#" [pRowToggler]="partner">
                    <i [ngClass]="expanded ? 'fas fa-minus-square' : 'fas fa-plus-square'"></i>
                </a>
            </td>
            <td>{{partner.PartnerUser.Person.IsActive  ? 'Active' : 'Inactive'}}</td>
            <td><span *ngIf="partner.PartnerUser.Person.LastName">{{partner.PartnerUser.Person.LastName}}, </span>{{partner.PartnerUser.Person.FirstName}}</td>
            <td>{{partner.PartnerUser.Person.Phone | phone}}</td>
            <td>{{partner.PartnerUser.Person.Email}}</td>
            <td>{{partner.PartnerUser.UniqueKey}}</td>
            <td>
                <i class="pi pi-fw pi-pencil action" (click)="editPartnerUser(partner)"></i> 
                <i class="pi pi-fw pi-trash action" (click)="deactivateUserConfirm(partner.RelationshipDataGroup[0].RelationshipId,partner.PartnerUser,partner)" *ngIf="!loading && partner.PartnerUser.Person.IsActive"></i>               
            </td>
        </tr>
    </ng-template> 
    <ng-template pTemplate="rowexpansion" let-partner>
        <tr>
            <td class="noBorderR">&nbsp;</td>
            <td [attr.colspan]=6 class="noBorderL">
                <table>
                    <tr>
                        <td colspan="2" class="expandHeader">Asset Groups</td>
                        <td colspan="2" class="expandHeader">Privileges</td>
                    </tr>
                    <tr>
                        <td class="noBorderR" colspan="2">{{partner.RelationshipDataGroup[0].RelationshipGroupName}}</td>
                        <td colspan="2">{{privilegeList(partner.PartnerUser.Privileges)}}</td>
                    </tr>
                </table>
            </td>
        </tr>
    </ng-template>
</p-table>
<app-add-partner-user *ngIf="displayAddDialog && partnerData" 
    [displayAddDialogInput]="displayAddDialog" 
    [partnerDetails]="partnerData" 
    (onDialogClose)="addDialogClose($event)" 
    (onNewPartnerUser)="newPartnerUser($event)"
    (onError)= errorMessage($event)>
</app-add-partner-user>
<app-edit-partner-user *ngIf="displayEditDialog && currentPartner" 
    [displayEditDialogInput]="displayEditDialog" 
    [partnerDetails]="currentPartner"
    [relationshipData]="partnerData"
    (onDialogClose)="editDialogClose($event)" 
    (onUpdatePartnerUser)="updatePartnerUser($event)"
    (onError)= errorMessage($event)>
</app-edit-partner-user>
<app-inactivate-partner-user *ngIf="displayInactivateDialog && currentPartner" 
    [displayInactivateInput]="displayInactivateDialog" 
    [partnerDetails]="currentPartner"
    [relationshipData]="partnerData"
    (onDialogClose)="editDialogClose($event)" 
    (onUpdatePartnerUser)="updatePartnerUser($event)"
    (onError)= errorMessage($event)>
</app-inactivate-partner-user>

<p-confirmDialog header="Deactivate Partnership User" icon="pi pi-exclamation-triangle"></p-confirmDialog>